import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import uuid from "uuid";
import './admin-employees.css';
import LinearProgress from '@material-ui/core/LinearProgress';
import ImageUpload from '../../components/ImageUpload/ImageUpload';
import { Box } from '@material-ui/core';
import { extractImageRef } from '../../utils/imageUtils';

class AdminEmployeesDialog extends Component {

  constructor(props) {
    super(props);

    this.isAddMode = true;

    this.state = {
      employee: {
        unikey: '',
        name: '',
        position: '',
        job: '',
        email: '',
        phone: '',
        description: '',
        image: 0,
        imageObject: null,
      },
      loading: true,
      originalImageId: null,
    };

    if (Object.keys(props.employeesData).length >= 1) {
      this.isAddMode = false;
      const { id: originalImageId, object: imageObject } = extractImageRef(props.employeesData.image);

      this.state.employee = {
        ...props.employeesData,
        name: props.employeesData.name || '',
        position: props.employeesData.position || '',
        job: props.employeesData.job || '',
        email: props.employeesData.email || '',
        phone: props.employeesData.phone || '',
        description: props.employeesData.description || '',
        image: originalImageId || 0,
        imageObject,
      };
      this.state.originalImageId = originalImageId;
      this.state.loading = false;
    } else {
      this.state.employee.unikey = uuid.v4();
      this.state.loading = false;
    }
  }

  handleField = (field) => (event) => {
    this.setState({
      employee: { ...this.state.employee, [field]: event.target.value }
    });
  }

  handleImageUpload = (uploadData) => {
    if (!uploadData || uploadData.cleared || !uploadData.id) {
      this.setState({
        employee: { ...this.state.employee, image: 0, imageObject: null },
      });
      return;
    }
    this.setState({
      employee: {
        ...this.state.employee,
        image: uploadData.id,
        imageObject: uploadData,
      },
    });
  }

  handleImageUploadError = () => {}

  submitDialog() {
    const employee = this.state.employee;
    const payload = {
      id: employee.id,
      name: employee.name || '',
      position: employee.position || '',
      job: employee.job || '',
      email: employee.email || '',
      phone: employee.phone || '',
      description: employee.description || '',
    };

    if (this.isAddMode || employee.image !== this.state.originalImageId) {
      payload.image = employee.image || 0;
    }

    this.props.submit(this.isAddMode, payload);
  }

  render() {
    const { employee } = this.state;

    return (
      <div>
        <DialogTitle id="form-dialog-title">Mitarbeiter { this.isAddMode ? "Erstellen" : "Bearbeiten" }</DialogTitle>
        { this.state.loading ? <LinearProgress color="primary" /> : <span className="loader-span"></span> }
        <DialogContent>
          <div className="pt-line-one">
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Name"
              type="text"
              fullWidth
              variant="outlined"
              value={employee.name}
              onChange={this.handleField('name')}
            />
            <TextField
              margin="dense"
              id="position"
              label="Position"
              helperText="z. B. Inhaber, Mechaniker"
              type="text"
              fullWidth
              variant="outlined"
              value={employee.position}
              onChange={this.handleField('position')}
            />
          </div>
          <div className="pt-line-one">
            <TextField
              margin="dense"
              id="job"
              label="Beruf"
              type="text"
              fullWidth
              variant="outlined"
              value={employee.job}
              onChange={this.handleField('job')}
            />
            <TextField
              margin="dense"
              id="phone"
              label="Telefon"
              type="text"
              fullWidth
              variant="outlined"
              value={employee.phone}
              onChange={this.handleField('phone')}
            />
          </div>
          <div className="pt-line-two">
            <TextField
              margin="dense"
              id="email"
              label="E-Mail"
              type="text"
              fullWidth
              variant="outlined"
              value={employee.email}
              onChange={this.handleField('email')}
            />
          </div>
          <div className="pt-line-two">
            <TextField
              margin="dense"
              id="description"
              label="Beschreibung"
              type="text"
              fullWidth
              variant="outlined"
              value={employee.description}
              onChange={this.handleField('description')}
            />
          </div>
          <Box style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Bild</label>
            <ImageUpload
              type="employee"
              name="Mitarbeiter"
              label="Bild hierher ziehen oder klicken"
              onUploadComplete={this.handleImageUpload}
              onUploadError={this.handleImageUploadError}
              currentImage={employee.imageObject}
              maxSizeMB={64}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <div className="p-line-end">
            <Button variant="contained" onClick={this.props.close}>
              Abbrechen
            </Button>
            <span></span>
            <Button variant="contained" color="primary" onClick={() => { this.submitDialog() }}>
              Speichern
            </Button>
          </div>
        </DialogActions>
      </div>
    );
  }
}

export default AdminEmployeesDialog;
